import { Guid } from "../../../../utilities/guid";
import { bindable } from "aurelia-framework";

export class YesNoControl {

    identifier: string = Guid.generateGuid();

    @bindable
    checked: boolean;

    @bindable
    readonly: boolean;

    @bindable
    naOption: boolean;

    protected onNoChecked = () => {
        this.checked = this.naOption ? false : (this.checked === false ? null : false);
    }

    protected onYesChecked = () => {
        this.checked = this.naOption ? true : (this.checked ? null : true);
    }

    protected onNAChecked = () => {
        this.checked = null;
    }
}
